import axios from 'axios';
import { toDefaultRequestTransforms, toDefaultResponseTransforms } from '@peloton/api/client-transforms';
import { SupportedTLD } from '@peloton/internationalize/models/locale';
export var AuthEnv;

(function (AuthEnv) {
  AuthEnv["Test"] = "https://auth-orca.test.k8s.onepeloton";
  AuthEnv["Stage"] = "https://auth-orca.stage.k8s.onepeloton";
  AuthEnv["Prod"] = "https://auth-orca.onepeloton";
})(AuthEnv || (AuthEnv = {}));

var authClient = function authClient() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AuthEnv.Prod;
  var tld = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SupportedTLD.Com;
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return axios.create({
    baseURL: "".concat(baseUrl).concat(tld),
    responseType: 'json',
    withCredentials: true,
    transformRequest: toDefaultRequestTransforms(),
    transformResponse: toDefaultResponseTransforms(),
    headers: headers
  });
};

export default authClient;